import * as React from 'react';
import Box from '@mui/material/Box';
import {
	DataGrid,
	GridToolbarContainer,
	GridToolbarExport,
} from '@mui/x-data-grid';
import { useSelector } from 'react-redux';
// import { Button } from '@mui/material';
import { Button, message, Popconfirm } from 'antd';
import EditIcon from '@mui/icons-material/Edit';
import { Document, Text, Page } from '@react-pdf/renderer';
import Html from 'react-pdf-html';

import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';
const rows = [
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456896',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456897',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456898',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456899',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456885',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456886',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456887',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
	{
		id: 'MFBF456888',
		depart: 'DEL',
		journey: 'DXB',
		dob: '12 / 10 / 2023',
		journeydate: '22/12/2023',
		cost: '₹8562',
	},
];

function CustomToolbar() {
	return (
		<GridToolbarContainer>
			<GridToolbarExport />
		</GridToolbarContainer>
	);
}
const html = `<html>
  <body>
    <style>
      .my-heading4 {
        background: darkgreen;
        color: white;
      }
      pre {
        background-color: #eee;
        padding: 10px;
      }
    </style>
    <h1>Heading 1</h1>
    <h2 style="background-color: pink">Heading 2</h2>
    <h3>Heading 3</h3>
    <h4 class="my-heading4">Heading 4</h4>
    <p>
      Paragraph with <strong>bold</strong>, <i>italic</i>, <u>underline</u>,
      <s>strikethrough</s>,
      <strong><u><s><i>and all of the above</i></s></u></strong>
    </p>
    <p>
      <a href="http://google.com">link</a>
    </p>
    <hr />
    <ul>
      <li>Unordered item</li>
      <li>Unordered item</li>
    </ul>
    <ol>
      <li>Ordered item</li>
      <li>Ordered item</li>
    </ol>
    <br /><br /><br /><br /><br />
    Text outside of any tags
    <table>
      <thead>
        <tr>
          <th>Column 1</th>
          <th>Column 2</th>
          <th>Column 3</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Foo</td>
          <td>Bar</td>
          <td>Foobar</td>
        </tr>
        <tr>
          <td colspan="2">Foo</td>
          <td>Bar</td>
        </tr>
        <tr>
          <td>Some longer thing</td>
          <td>Even more content than before!</td>
          <td>Even more content than before!</td>
        </tr>
      </tbody>
    </table>
    <div style="width: 200px; height: 200px; background: pink"></div>
    <pre>
function myCode() {
  const foo = 'bar';
}
</pre>
  </body>
</html>
`;
export default function DataGridD() {
	const { bookinghistoryagent } = useSelector((state) => state.user);
	const navigate = useNavigate();
	const columns = [
		{ field: 'orderId', headerName: 'ORDER ID', width: 150 },
		{
			field: 'origin',
			headerName: 'DEPART FROM',
			width: 150,
			editable: true,
		},
		{
			field: 'destination',
			headerName: 'JOURNEY TO',
			width: 150,
			editable: true,
		},
		{
			field: 'dob',
			headerName: 'DATE OF BOOKING',
			type: 'number',
			width: 150,
			editable: true,
		},
		{
			field: 'travelDate',
			headerName: 'JOURNEY DATE',
			description: 'This column has a value getter and is not sortable.',
			width: 160,
			type: 'number',
			editable: true,
		},
		{
			field: 'ticketCost',
			headerName: 'TICKET COST',
			type: 'number',
			width: 150,
			editable: true,
		},
		{
			field: 'action',
			headerName: 'ACTIONS',
			width: 300,
			renderCell: (cellValues) => {
				return (
					<>
						<Box
							onClick={() => navigate('/ticket', { state: cellValues.row })}
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								border: '1px solid lightgrey',
								padding: 4,
								borderRadius: 5,
								cursor: 'pointer',
							}}>
							<span style={{ fontSize: 12 }}>View</span>
							<VisibilityIcon style={{ marginLeft: 10 }} />
						</Box>
						<Popconfirm
							title='Email the Ticket'
							description='Are you sure to email this ticket?'
							// onConfirm={confirm}
							// onCancel={cancel}
							okText='Yes'
							cancelText='No'>
							<Button>Email</Button>
						</Popconfirm>
					</>
				);
			},
		},
	];
	const handleDownload = () => {
		<Document>
			<Page>
				<Html>{html}</Html>
			</Page>
		</Document>;
	};
	return (
		<Box sx={{ height: 600, width: '100%' }}>
			{bookinghistoryagent?.result?.flights.length > 0 ? (
				<DataGrid
					rows={bookinghistoryagent?.result?.flights}
					columns={columns}
					initialState={{
						pagination: {
							paginationModel: {
								pageSize: 10,
							},
						},
					}}
					slots={{
						toolbar: CustomToolbar,
					}}
					pageSizeOptions={[5]}
					checkboxSelection
					disableRowSelectionOnClick
				/>
			) : (
				''
			)}
		</Box>
	);
}
